import { RedeemLimitType } from "enums";
import locale from "localization";
import { prettifyRedeemLimitType } from "utils";
import Validation from "utils/validation.utils";

export const ACCOUNT_TYPE_GROUP_OPTIONS = [
  { label: locale.accountTypeGroupPrivateConsumerUnverified, value: "private_consumer_unverified" },
  { label: locale.accountTypeGroupPrivateConsumerVerified, value: "private_consumer_verified" },
  { label: locale.accountTypeGroupTnvs, value: "tnvs" },
  { label: locale.accountTypeGroupBiz, value: "biz" },
  { label: locale.accountTypeGroupPublic, value: "public" },
  { label: locale.accountTypeGroupSeaoilVerified, value: "seaoil_verified" },
];

const num = (field) => ({
  name: field,
  validations: [Validation.numeric()],
  innerLabel: true,
  parseNumber: true,
  horizontal: true,
});

export const initialState = (state = {}) => {
  const {
    name = { value: "" },
    walletSize = { value: "" },
    fuelTankSize = { value: "" },
    totalCashinLimitDaily = { value: "" },
    totalCashinLimitMonthly = { value: "" },
    totalTransactionCardDaily = { value: "" },
    totalTransactionCardMonthly = { value: "" },
    totalBuyFuelLimitDaily = { value: "" },
    totalBuyFuelLimitMonthly = { value: "" },
    totalPayWithPesoLimitDaily = { value: "" },
    totalPayWithPesoLimitMonthly = { value: "" },
    totalRedeemLimitDaily = { value: "" },
    totalRedeemLimitType = { value: "" },
    totalRedemptionLiterLimitDaily = { value: "" },
    accountTypeGroup = { value: "" },
    tierCode = { value: "" },
    tierLevel = { value: "" },
    tierThresholdLiters = { value: "" },
    fuelEarningLitersPerPoint = { value: "" },
    nonfuelEarningPesoPerPoint = { value: "" },
    pointsEarnDaily = { value: "" },
    pointsEarnWeekly = { value: "" },
    pointsEarnMonthly = { value: "" },
    pointsEarnTxnCapDaily = { value: "" },
    pointsEarnTxnCapWeekly = { value: "" },
    pointsEarnTxnCapMonthly = { value: "" },
    pointsRedeemDaily = { value: "" },
    pointsRedeemWeekly = { value: "" },
    pointsRedeemMonthly = { value: "" },
    pointsRedeemCapDaily = { value: "" },
    pointsRedeemCapWeekly = { value: "" },
    pointsRedeemCapMonthly = { value: "" },
  } = state;

  return {
    name: {
      name: "name",
      required: true,
      validations: [Validation.name(), Validation.required({ noMessage: true })],
      maxLength: 25,
      label: locale.accountTypeName,
      horizontal: true,
      ...name,
    },
    accountTypeGroup: {
      name: "accountTypeGroup",
      label: locale.tierName,
      horizontal: true,
      options: ACCOUNT_TYPE_GROUP_OPTIONS,
      ...accountTypeGroup,
    },
    tierCode: {
      name: "tierCode",
      label: locale.tierCode,
      horizontal: true,
      maxLength: 64,
      ...tierCode,
    },
    tierLevel: {
      name: "tierLevel",
      label: locale.tierLevel,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      validations: [Validation.numeric()],
      ...tierLevel,
    },
    tierThresholdLiters: {
      name: "tierThresholdLiters",
      label: locale.tierThresholdLiters,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      validations: [Validation.numeric()],
      ...tierThresholdLiters,
    },
    walletSize: {
      name: "walletSize",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: locale.pesoWalletSize,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...walletSize,
    },
    fuelTankSize: {
      name: "fuelTankSize",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: locale.fuelTankSize,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...fuelTankSize,
    },
    totalCashinLimitDaily: {
      name: "totalCashinLimitDaily",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: locale.totalCashInLimit,
      subLabel: locale.willOverrideViaCardLimit,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalCashinLimitDaily,
    },
    totalCashinLimitMonthly: {
      name: "totalCashinLimitMonthly",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: true,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalCashinLimitMonthly,
    },
    totalTransactionCardDaily: {
      name: "totalTransactionCardDaily",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: locale.transactionsViaCard,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalTransactionCardDaily,
    },
    totalTransactionCardMonthly: {
      name: "totalTransactionCardMonthly",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: true,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalTransactionCardMonthly,
    },
    totalBuyFuelLimitDaily: {
      name: "totalBuyFuelLimitDaily",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: locale.totalBuyFuelLimit,
      subLabel: locale.willOverrideViaCardLimit,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalBuyFuelLimitDaily,
    },
    totalBuyFuelLimitMonthly: {
      name: "totalBuyFuelLimitMonthly",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: true,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalBuyFuelLimitMonthly,
    },
    totalPayWithPesoLimitDaily: {
      name: "totalPayWithPesoLimitDaily",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: locale.totalPayWithPesoLimit,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalPayWithPesoLimitDaily,
    },
    totalPayWithPesoLimitMonthly: {
      name: "totalPayWithPesoLimitMonthly",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: true,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalPayWithPesoLimitMonthly,
    },
    totalRedeemLimitDaily: {
      name: "totalRedeemLimitDaily",
      required: true,
      validations: [Validation.required({ noMessage: true }), Validation.numeric()],
      label: locale.redemptionLimit,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalRedeemLimitDaily,
    },
    totalRedeemLimitType: {
      name: "totalRedeemLimitType",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      horizontal: true,
      options: [
        { label: prettifyRedeemLimitType(RedeemLimitType.Station), value: RedeemLimitType.Station },
        { label: prettifyRedeemLimitType(RedeemLimitType.Universal), value: RedeemLimitType.Universal },
      ],
      ...totalRedeemLimitType,
    },
    totalRedemptionLiterLimitDaily: {
      name: "totalRedemptionLiterLimitDaily",
      required: true,
      validations: [Validation.required({ noMessage: true })],
      label: locale.literLimit,
      innerLabel: true,
      parseNumber: true,
      horizontal: true,
      ...totalRedemptionLiterLimitDaily,
    },
    fuelEarningLitersPerPoint: {
      ...num("fuelEarningLitersPerPoint"),
      label: locale.fuelEarningRate,
      ...fuelEarningLitersPerPoint,
    },
    nonfuelEarningPesoPerPoint: {
      ...num("nonfuelEarningPesoPerPoint"),
      label: locale.nonfuelEarningRate,
      ...nonfuelEarningPesoPerPoint,
    },
    pointsEarnDaily: { ...num("pointsEarnDaily"), label: locale.pointsEarnLimit, ...pointsEarnDaily },
    pointsEarnWeekly: { ...num("pointsEarnWeekly"), label: true, ...pointsEarnWeekly },
    pointsEarnMonthly: { ...num("pointsEarnMonthly"), label: true, ...pointsEarnMonthly },
    pointsEarnTxnCapDaily: { ...num("pointsEarnTxnCapDaily"), label: locale.pointsEarnCap, ...pointsEarnTxnCapDaily },
    pointsEarnTxnCapWeekly: { ...num("pointsEarnTxnCapWeekly"), label: true, ...pointsEarnTxnCapWeekly },
    pointsEarnTxnCapMonthly: { ...num("pointsEarnTxnCapMonthly"), label: true, ...pointsEarnTxnCapMonthly },
    pointsRedeemDaily: { ...num("pointsRedeemDaily"), label: locale.pointsRedeemLimit, ...pointsRedeemDaily },
    pointsRedeemWeekly: { ...num("pointsRedeemWeekly"), label: true, ...pointsRedeemWeekly },
    pointsRedeemMonthly: { ...num("pointsRedeemMonthly"), label: true, ...pointsRedeemMonthly },
    pointsRedeemCapDaily: { ...num("pointsRedeemCapDaily"), label: locale.pointsRedeemCap, ...pointsRedeemCapDaily },
    pointsRedeemCapWeekly: { ...num("pointsRedeemCapWeekly"), label: true, ...pointsRedeemCapWeekly },
    pointsRedeemCapMonthly: { ...num("pointsRedeemCapMonthly"), label: true, ...pointsRedeemCapMonthly },
  };
};
